import React, { FC } from 'react';
import { tint } from 'src/shared/globals';
import styled from 'styled-components';
import { HelpIcon } from '../areaDesigner/icons';

const Container = styled.a`
    position: absolute;
    right: 20px;
    top: 20px;
    background-color: #aecb54;
    border: 4px white solid;
    border-radius: 50%;
    width: 54px;
    height: 54px;
    font-size: 40px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;

    &:hover {
        background-color: ${tint('#aecb54', 10)};
    }
`;

const Help: FC<{ url: string; className?: string }> = ({ url, className }) => {
    return (
        <Container href={url} target='_blank' className={className}>
            <HelpIcon />
        </Container>
    );
};

export default Help;
